import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../assets/page-image/cyhd/banner.png';
const _hoisted_1 = {
  class: "cyhd-wrapper"
};
const _hoisted_2 = {
  class: "cyhd-page"
};
const _hoisted_3 = {
  class: "title-section"
};
const _hoisted_4 = {
  key: 0,
  class: "section"
};
const _hoisted_5 = {
  class: "cards-container"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "card-image"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
  class: "card-title"
};
const _hoisted_10 = {
  class: "card-date"
};
const _hoisted_11 = {
  class: "card-desc"
};
const _hoisted_12 = {
  key: 1,
  class: "section"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "list-image"
};
const _hoisted_15 = ["src", "alt"];
const _hoisted_16 = {
  class: "list-content"
};
const _hoisted_17 = {
  class: "list-title"
};
const _hoisted_18 = {
  class: "list-date"
};
const _hoisted_19 = {
  class: "list-text"
};
const _hoisted_20 = {
  key: 2,
  class: "empty-data"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getActivityPageListByType } from '@/api/entrepreneurship';
export default /*@__PURE__*/_defineComponent({
  __name: 'Cyhd',
  setup(__props) {
    const router = useRouter();
    // 当前激活的tab索引 (0: 赛事, 1: 培训, 2: 路演, 3: 交流)
    const activeTabIndex = ref(0);
    // 活动列表数据
    const activityList = ref([]);
    // 总数
    const total = ref(0);
    // 分页参数
    const pageNum = ref(1);
    const pageSize = ref(10);
    // 加载状态
    const loading = ref(false);
    // 日期格式化函数
    const formatDate = dateString => {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}年 ${month}月 ${day}日`;
    };
    // 跳转到详情页
    const goToDetail = id => {
      router.push(`/cyhd/${id}`);
    };
    // 获取活动列表
    const getActivityList = async () => {
      try {
        loading.value = true;
        // 根据activeTabIndex转换为type值：0->1, 1->2, 2->3, 3->4
        const type = activeTabIndex.value + 1;
        const res = await getActivityPageListByType({
          pageNum: pageNum.value,
          pageSize: pageSize.value,
          type
        });
        if (res.code === 200) {
          activityList.value = res.data || [];
          total.value = res.total || 0;
        }
      } catch (error) {
        console.error('获取活动列表失败:', error);
        activityList.value = [];
      } finally {
        loading.value = false;
      }
    };
    // tab切换处理函数
    const handleTabChange = index => {
      activeTabIndex.value = index;
      pageNum.value = 1; // 切换tab时重置页码
      getActivityList();
    };
    // 页面加载时获取数据
    onMounted(() => {
      getActivityList();
    });
    return (_ctx, _cache) => {
      const _component_SectionTitleWithTabs = _resolveComponent("SectionTitleWithTabs");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "创业活动"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SectionTitleWithTabs, {
        title: "赛事",
        "show-more": false,
        "show-tabs": true,
        tabs: ['培训', '路演', '交流'],
        onTabChange: handleTabChange
      })]), activityList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityList.value.slice(0, 3), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "card",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: item.coverImage,
          alt: item.title
        }, null, 8, _hoisted_8)]), _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(formatDate(item.publishTime)), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(item.summary), 1)], 8, _hoisted_6);
      }), 128))])])) : _createCommentVNode("", true), activityList.value.length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityList.value.slice(3), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
          src: item.coverImage,
          alt: item.title
        }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(formatDate(item.publishTime)), 1), _createElementVNode("div", _hoisted_19, _toDisplayString(item.summary), 1)])], 8, _hoisted_13);
      }), 128))])) : _createCommentVNode("", true), !loading.value && activityList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无数据", -1)]))])) : _createCommentVNode("", true)]), _createVNode(_component_Footer)]);
    };
  }
});